var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInprogressTaskPerfomance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17811",
    "data-name": "Group 17811",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34709",
    "data-name": "Path 34709",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34710",
    "data-name": "Path 34710",
    d: "M5.463,4.433A10,10,0,0,1,20.19,17.74L17,12h3A8,8,0,0,0,6.46,6.228l-1-1.8ZM18.537,19.567A10,10,0,0,1,3.81,6.26L7,12H4a8,8,0,0,0,13.54,5.772Z",
    fill: "#ffb74d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogressTaskPerfomance);
export default __webpack_public_path__ + "static/media/inprogress_task_perfomance.9eabdec3b78bf7ddc55ab7b014384017.svg";
export { ForwardRef as ReactComponent };